var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCheckCpf(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.87 11.598c0-.219.01-.438.035-.657H2.448a.557.557 0 01-.555-.558V8.538h6.81c.223-.382.488-.735.792-1.06H1.893V2.484c0-.304.248-.555.555-.555h14.865c.307 0 .555.25.555.558v4.545a6.228 6.228 0 011.06 1.187V2.453c0-.894-.725-1.619-1.615-1.619H2.448c-.89 0-1.615.725-1.615 1.619v7.934c0 .89.725 1.615 1.615 1.615h5.436c-.007-.134-.015-.268-.015-.403zm1.063-.01A4.986 4.986 0 0113.92 6.6a4.986 4.986 0 110 9.973 4.955 4.955 0 01-3.312-1.258L7.664 18.26a.533.533 0 01-.749 0 .527.527 0 010-.749l2.98-2.98a4.958 4.958 0 01-.962-2.943zm4.987 3.93c1.05 0 2.036-.41 2.778-1.152a3.912 3.912 0 001.152-2.778c0-1.05-.41-2.036-1.152-2.778a3.903 3.903 0 00-2.778-1.152c-1.05 0-2.036.41-2.778 1.152a3.903 3.903 0 00-1.152 2.778c0 1.05.41 2.035 1.152 2.778a3.903 3.903 0 002.778 1.152zm2.07-3.927a.354.354 0 00.707 0 2.78 2.78 0 00-2.777-2.778.354.354 0 00-.354.354c0 .194.16.353.354.353 1.141 0 2.07.93 2.07 2.071z",
    fill: "#E63888"
  })));
}

export default "/assets/ecs/lno/ecs-lno-frontend-concierge/3.6.2/_next/static/images/check-cpf-e7168d1176316143ac1272defaf2a2e0.svg";
export { SvgCheckCpf as ReactComponent };